import { ReactNode, useMemo } from 'react';

export interface MainLayoutContentWrapperProps {
  children: ReactNode;
  showSidebar?: boolean;
}

const MainLayoutContentWrapper: React.FunctionComponent<MainLayoutContentWrapperProps> =
  function ({ children, showSidebar = true }) {
    const className = useMemo(
      () =>
        [
          'flex flex-1 flex-col w-full',
          showSidebar ? 'max-w-240 ml-auto' : 'max-w-360 mx-auto',
        ].join(' '),
      [showSidebar],
    );
    return <div className={className}>{children}</div>;
  };

export default MainLayoutContentWrapper;
